'use client'

import { useEffect } from 'react'
import { useLocale } from '@/contexts/LocaleContext'

export function HtmlLangUpdater() {
  const { locale } = useLocale()

  useEffect(() => {
    // Map locale to full language code
    const langCode = locale === 'pt' ? 'pt-BR' : 'en'
    document.documentElement.lang = langCode
  }, [locale])

  return null
}
